import { React } from 'react';
import SatelliteText from '../SatelliteText/SatelliteText';

// Renders an h3 group (`<prefix>.title`, black bar) followed by its topics (`<prefix>.<n>.title`),
// each with its text (`<prefix>.<n>.text`); the number of topics can differ per language
// noGroupTitle: topics only, without the black bar (when the topics sit directly under the section title)
// tag: heading tag of the topics (h4 by default)
// first: space above the first topic (right after a section title)
// noPadBottom: no space after the last text (when the topics end the section)
const SatelliteTopics = props => {
    const topics = Object.keys(props.t(props.prefix, { returnObjects: true })).filter(key => !isNaN(key));
    const Heading = props.tag || 'h4';
    return (
        <>
            {!props.noGroupTitle && <div className='title-container solo'>
                <div className='container-custom title p-0'>
                    <h3 className='d-flex justify-content-between justify-content-md-start'>{props.t(props.prefix + '.title')}</h3>
                </div>
            </div>}
            {topics.map((topic, index) => (
                <div key={topic} className={index === 0 && props.first ? 'container-custom subtitle first' : 'container-custom subtitle'}>
                    <Heading className='title'>{props.t(props.prefix + '.' + topic + '.title')}</Heading>
                    <SatelliteText t={props.t} prefix={props.prefix + '.' + topic} noPadBottom={props.noPadBottom && index === topics.length - 1} />
                </div>
            ))}
        </>
    );
};

export default SatelliteTopics;
